import { Typography } from '@mui/material'
import PageContainer from 'components/PageContainer'
import { useBalance } from 'hooks/useBalance'
import { usePool } from 'hooks/usePool'
import { useMemo } from 'react'
import BorrowMarketTable from './BorrowMarketTable'
import AccountInfoCard from './AccountInfoCard'
import SupplyMarketTable from './SupplyMarketTable'
import PoolInfoCard from './PoolInfoCard'
import AssetInfoCard from './AssetInfoCard'
import GiveFeedback from 'components/GiveFeedback'
import { observer } from 'mobx-react-lite'
import { poolStore } from 'stores'
import { poolService } from 'services/poolService'

const LendAndBorrow = observer(() => {
  const poolAddr = poolService.poolAddress
  const { supplyMarketList } = poolStore.getPool(poolAddr)
  const tokens = useMemo(() => {
    if (!supplyMarketList) return []

    return [
      ...supplyMarketList.map((market) => market.underlying),
      ...supplyMarketList.map((market) => market.etoken_addr),
    ]
  }, [supplyMarketList])
  usePool()
  useBalance(tokens)

  return (
    <PageContainer>
      <Typography variant="h4">Genesis Pool</Typography>
      <GiveFeedback />
      <AccountInfoCard />
      <SupplyMarketTable />
      <BorrowMarketTable />
      <PoolInfoCard />
      <AssetInfoCard />
    </PageContainer>
  )
})

export default LendAndBorrow
